<template>
    <div>
        <v-navigation-drawer v-model="drawer" fixed temporary right width="40%">
            <v-list-item style="background-color:#A553BB" dark>
                <v-list-item-content>
                    <v-list-item-title>CENTRAL DE AJUDA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
          <v-btn @click="drawer=false" fab small elevation="2" color="white">
            <v-icon  color="black">close</v-icon>
          </v-btn>
        </v-list-item-icon>
        
            </v-list-item>

            <v-divider></v-divider>
            <div class="my-5 px-5">
                <template v-if="tag == 'work_title'">
                    <h2>Titulo da Obra</h2>
                    <p>Nome ou Título que o(s) compositor(es) deram à obra musical.</p>
                    <p>Esse título é o mesmo que deverá ser usado para vincular essas obras às suas faixas e "montar" a ordem musical seus produtos.</p>
                    <p>Quando uma obra é vinculada à uma faixa ela se torna um fonograma, ou seja, uma gravação.</p>
                </template>

                <template v-if="tag == 'work_iswc'">
                    <h2>ISWC</h2>
                    <p>Abreviação de "International Standard Musical Work Code", é um código identificador único e exclusivo para obras musicais. Esse é o código de registro da obra.</p>
                    <p>Caso a obra que você estiver adicionando tiver esse código recomendamos que você o adicione.</p>
                        
                </template>

                <template v-if="tag == 'work_version'">
                    <h2>Versão</h2>
                    <p>Marque essa opção se a obra que está cadastrando é uma versão de alguma outra obra conhecida.</p>
                </template>

                <template v-if="tag == 'work_original_title'">
                    <h2>Titulo da Obra Original</h2>
                    <p>Esse é o nome da obra original, aquela que foi usada para criar essa versão que está cadastrando.</p>
                </template>

                <template v-if="tag == 'work_lyrics'">
                    <h2>Letra</h2>
                    <p>Digite nesse campo a letra completa da obra que você está cadastrando.</p>
                </template>

                <template v-if="tag == 'work_percentile'">
                    <h2>Percentual</h2>
                    <p>O valor percentual que tem direito</p>
                </template>
            </div>
        </v-navigation-drawer>
    </div>
</template>
<script>
export default {
    data() {
        return {
            drawer: null,
            tag: null
        };
    },
    methods: {
        show(tag) {
            if (!tag) {
                return;
            }

            this.drawer = true;
            this.tag = tag;
        }
    }
};
</script>